import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BeWomanLogo } from "@/components/BeWomanLogo";
import { ArrowRight, Heart, Dumbbell, Sparkles, Briefcase } from "lucide-react";

const PILLARS = [
  { icon: Heart, name: "Cuore", sub: "L'amore", color: "#E2537D" },
  { icon: Dumbbell, name: "Fitness", sub: "Il corpo", color: "#E32C8C" },
  { icon: Sparkles, name: "Beauty", sub: "Piacersi", color: "#C03276" },
  { icon: Briefcase, name: "Realizzazione", sub: "La libertà", color: "#96235C" },
];

export function Landing() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const start = () => {
    if (!loading && user) navigate("/test");
    else navigate("/register");
  };

  return (
    <div className="min-h-[100dvh] bg-[#00000000]">
      <div className="max-w-md md:max-w-2xl mx-auto min-h-[100dvh] px-6 py-10 flex flex-col">
        <div className="flex-1 flex flex-col items-center justify-center text-center bw-fade">
          <BeWomanLogo size="large" className="mb-2" />

          <p
            className="font-serif text-2xl sm:text-3xl font-semibold text-[#F04B9B] tracking-wide mt-4"
            data-testid="brand-payoff"
          >
            PIÙ CONSAPEVOLE.<br />PIÙ LIBERA. PIÙ TU.
          </p>
          <p className="text-[#EAC6D9] mt-3 text-base italic font-serif">
            La tua versione migliore ogni giorno
          </p>

          <div className="grid grid-cols-4 gap-2 mt-8 w-full max-w-sm">
            {PILLARS.map((p) => (
              <div key={p.name} className="flex flex-col items-center gap-1.5">
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: `${p.color}1A` }}
                >
                  <p.icon className="w-5 h-5" style={{ color: p.color }} />
                </div>
                <span className="text-[11px] font-semibold text-[#EAC6D9] leading-tight">{p.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="pb-2">
          <button
            onClick={start}
            data-testid="start-test-btn"
            className="w-full bg-gradient-to-r from-[#E32C8C] to-[#8E1A52] text-white font-semibold py-4 px-6 rounded-full shadow-lg shadow-[#E32C8C]/25 bw-glow hover:opacity-95 active:scale-[0.98] transition-all flex items-center justify-center gap-2 text-lg"
          >
            Inizia ora <ArrowRight className="w-5 h-5" />
          </button>
          <button
            onClick={() => navigate("/login")}
            data-testid="landing-login-link"
            className="w-full mt-3 text-[#EAC6D9] text-sm font-medium py-2"
          >
            Ho già un account · <span className="text-[#E32C8C] font-semibold underline">Accedi</span>
          </button>
        </div>
      </div>
    </div>
  );
}
